import { Card, CardHeader, Heading, CardBody, FormControl, Select, Container, Tag, Flex, Box, Spacer, FormLabel, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper } from "@chakra-ui/react";
import MyBreadcrumb from "components/breadcrumb/Breadcrumb";
import { useEffect, useState } from "react";
import TreeView, { flattenTree } from "react-accessible-treeview";
import { useSelector } from "react-redux";
import { fromDocumentToTreeViewObject } from "utils/utils";
import BulletIcon from "./components/BulletIcon";
import StatusTag from "./components/StatusTag";
import ProgressBar from "@ramonak/react-progress-bar";
import { Breadcrumb } from "types/Breadcrumb";


type OverviewPageProps = {

};

/**
 * OverviewPage component displays an overview of a document.
 * 
 * @component
 * 
 * @example
 * return (
 *   <OverviewPage />
 * )
 */

export default function OverviewPage({ }: OverviewPageProps) {

  const selectedDocumentId = useSelector((state: any) => state.documents.selectedDocumentId);
  const selectedDocument = useSelector((state: any) => state.documents.documents.find((doc: any) => doc._id === selectedDocumentId));
  const [treeObject, setTreeObject] = useState<any>([]);
  const [timePeriod, setTimePeriod] = useState<string>("");

  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);

  const handleOnChangeTimePeriod = (value: any) => {
    setTimePeriod(value);
  }

  useEffect(() => {
    if (timePeriod) {
      const treeObject: any = fromDocumentToTreeViewObject(selectedDocument, timePeriod);
      const flattenTreeObject = flattenTree(treeObject);
      setTreeObject(flattenTreeObject);
    }
  }, [timePeriod])

  const breadcrumb: Breadcrumb = new Breadcrumb(
    [
      { label: "Panoramica dati", link: "/overview", value: "", isActive: false },
    ]
  );


  return (
    <section className="dashboard-first-section">
      <Container maxW="container.lg" maxH={"container.xl"} textAlign={"left"}>
        <MyBreadcrumb breadcrumb={breadcrumb} />


        <Card minH={"60vh"}>
          <CardHeader>
            <Heading as="h1" size="xl">
              Panoramica documento: {document?.title} ({selectedDocument?.code})
            </Heading>
          </CardHeader>
          <CardBody>
            <form>
              <FormControl isRequired>
                <FormLabel htmlFor="selected-time-period">Seleziona un periodo d'inserimento</FormLabel>

                <NumberInput
                  id="selected-time-period"
                  step={1}
                  min={2023}
                  onChange={(val) => handleOnChangeTimePeriod(val)}
                >

                  <NumberInputField
                    placeholder={`Digita un anno (e.g.${currentYear})`}
                  />
                  <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                  </NumberInputStepper>
                </NumberInput>
              </FormControl>

            </form>

            {
              timePeriod != "" && treeObject && treeObject.length > 0 &&
              <div className="directory">
                <TreeView
                  data={treeObject}
                  nodeRenderer={({ element, getNodeProps, level, handleSelect, isExpanded }) =>
                  (
                    level == 1 ?
                      <>
                        <div {...getNodeProps()} style={{ paddingLeft: 30 * (level - 1) }}>
                          <Card variant={"outline"} p={1}>
                            <Flex alignContent={"stretch"}>
                              <Box>
                                <Tag colorScheme={element.metadata?.is_filled ? "green" : "gray"} marginRight={2} variant={"outline"} minHeight={"100%"}>
                                  {element.metadata?.element}  {element.metadata?.index}
                                </Tag>
                              </Box>
                              <Box w={"80%"}>
                                <span>
                                  Percentuale di completamento ({element.metadata?.number_of_filled_indicators} indicatori completati su {element.metadata?.number_of_indicators} indicatori totali)
                                </span>
                                <Box w="50%">
                                  <ProgressBar completed={Number(((Number(element.metadata?.number_of_filled_indicators) / Number(element.metadata?.number_of_indicators)) * 100).toFixed(0))} maxCompleted={100} bgColor={"green"} borderRadius={"1em"}
                                    height="1.25em"
                                    labelSize="1em"
                                  />
                                </Box>
                              </Box>
                              <Spacer />
                              <Box>
                                <BulletIcon isFilled={element.metadata?.is_filled as boolean} isOpen={isExpanded} isIndicator={element.metadata?.element == "Indicatore"} />
                              </Box>
                            </Flex>
                          </Card>
                        </div>
                      </>
                      :
                      <div {...getNodeProps()} style={{ paddingLeft: 30 * (level - 1) }}>
                        <Flex fontSize={"small"} mb={1}>
                          <Box w="15%">
                            <Tag colorScheme={element.metadata?.is_filled ? "green" : "gray"} marginRight={2} variant={"outline"} minHeight={"100%"} fontSize={"small"}>
                              {element.metadata?.element}  {element.metadata?.index}
                            </Tag>
                          </Box>
                          <Spacer />
                          <Box w="10%">
                            <StatusTag isFilled={element.metadata?.is_filled} />
                          </Box>
                          <Box p={1} w="80%">
                            {element.name}
                          </Box>
                          <Spacer />
                          <Box>
                            <BulletIcon isFilled={element.metadata?.is_filled as boolean} isOpen={isExpanded} isIndicator={element.metadata?.element == "Indicatore"} />
                          </Box>
                        </Flex>
                        <hr />
                      </div>

                  )}
                />
              </div>
            }
          </CardBody>
        </Card>
      </Container>
    </section >
  );
}